module.exports = __webpack_public_path__ + "img/trianglecube.49d32bdb.webp";